'use strict';
const localStorageSlim = require('localstorage-slim');
const cacheConfig = require('public/js/lib/cache-config');
const { LOCATION_CHANGED_EVENT } = require('public/js/lib/location-events');
const {
	clearModalZipError,
	enableZipInputAutoFocusOnShown,
	getTrimmedModalPostalCodeOrShowError,
	submitManualZipAndReload,
} = require('public/js/lib/location-modal-update');

/** PDP modal uses the same markup but is wired by product-message-utils; exclude from header handlers. */
const HEADER_LOCATION_MODULE = '.location-module:not(.pdp-zip-location-modal-host)';

import './location.scss';

function getLocationCache() {
	try {
		return localStorageSlim.get(cacheConfig.LOCATION_CACHE_KEY);
	} catch {
		return null;
	}
}

const THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');
	const { formatHeaderDisplayPostal } = require('./location-helpers');
	const { isEnterKeyUpEvent } = require('public/js/lib/keyboard-helpers');
	let $locationDisplays;

	$onReady({rp$, window: globalThis,
		label: 'location',
		fn: function () {
			$locationDisplays = rp$(`${HEADER_LOCATION_MODULE} .location-value`);

			rp$(`${HEADER_LOCATION_MODULE} .location-header`).on('click', function (e) {
				e.preventDefault();
				const $modal = rp$(this).closest('.location-module').find('.location-modal');
				if ($modal.length) {
					$modal.modal('show');
				}
			});

			rp$(`${HEADER_LOCATION_MODULE} .enter-zip-button`).on('click', handleZipSubmission);
			rp$(document).on(LOCATION_CHANGED_EVENT, function handleLocationChanged(_event, payload) {
				if (
					payload?.resolutionTerminal === true
					&& payload?.hasResolvedLocation === false
				) {
					$locationDisplays.html('');
					return;
				}
				const postalCode = String(payload?.postalCode ?? '').trim();
				if (postalCode === '' || !payload?.location) {
					return;
				}
				$locationDisplays.html(formatHeaderDisplayPostal(postalCode, payload.location));
			});
			rp$(`${HEADER_LOCATION_MODULE} .zip-input`).on('keyup', function handleZipEnterKeyed(e) {
				const $modal = rp$(this).closest('.location-modal');
				clearModalZipError($modal);

				if (isEnterKeyUpEvent(e)) {
					e.preventDefault();
					handleZipSubmission(e);
				}
			});

			const cachedLocation = getLocationCache();
			if (cachedLocation?.location) {
				$locationDisplays.html(formatHeaderDisplayPostal(cachedLocation.postalCode, cachedLocation.location));
			} else {
				$locationDisplays.html('<i class="fa fa-spinner fa-pulse"></i>');
			}

			rp$('.location-modal').not('.pdp-zip-code-modal').on('show.bs.modal', function () {
				const $modal = rp$(this);
				const cached = getLocationCache();
				$modal.find('.zip-input').val(cached?.postalCode || '');
			});

			enableZipInputAutoFocusOnShown();
		},
	});

	function handleZipSubmission(e) {
		e.preventDefault();

		const $trigger = rp$(e.currentTarget);
		const $modal = $trigger.closest('.location-modal');
		const $button = $modal.find('.enter-zip-button');
		const postalCode = getTrimmedModalPostalCodeOrShowError(
			$modal,
			$modal.find('.zip-input').val()
		);
		if (postalCode === null) {
			return;
		}

		submitManualZipAndReload({postalCode}, $modal, $button, (displayPostal, location) => {
			$locationDisplays.html(formatHeaderDisplayPostal(displayPostal, location));
		});
	}
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	if (typeof __CURRENT_SCRIPT__ === 'undefined') {
		throw new Error('__CURRENT_SCRIPT__ is not defined');
	}
	// Sonarqube errors if no keyword is used here.  let/const would break injection, so using var...
	var __CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
